// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3aouZ","footer":"ModalFilter_footer__2faxu"};